import {FormControl, withStyles} from '@material-ui/core';

export default withStyles(({typography, spacing}) => ({
  root: {
    '& label, legend': {
      transform: 'none',
      position: 'initial',
      fontFamily: typography.bold,
      marginBottom: spacing(1),
      lineHeight: 1.3
    },
    '& .no-label-margin': {
      '& label, legend': {
        marginBottom: 0
      }
    },
    '& .description': {
      marginBottom: 5,
      '& p': {
        margin: 0
      }
    },
    '& .radio-group': {
      '&.row': {
        '& > label': {
          marginRight: 30
        }
      },
      '& > label': {
        marginBottom: 0
      }
    },
    '& select': {
      paddingTop: 13
    }
  },
}))(FormControl);
